import axios from './axios';
import Mappings from './api.mappings';
export class BizpropertyApi {
    sortkeys(params) {
        return axios.put(Mappings.bizproperty.sortkeys, params);
    }
}
;
